module.exports = __webpack_public_path__ + "img/博世华域.png";